var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wary"},[_c('el-image',{staticStyle:{"box-shadow":"0 0 5px #ddd"},style:({
			'width':_vm.width+'px',
			'height':_vm.height+'px',
			'border-radius':_vm.borderRadius+'px' }),attrs:{"src":_vm.imgSrc}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{style:({
			'width':_vm.width+'px',
			'height':_vm.height+'px',
			'border-radius':_vm.borderRadius+'px' }),attrs:{"src":require("../../static/images/morenImg.png")}})])]),(_vm.gender==1&&_vm.isGender)?_c('i',{staticClass:"wzk-nan wzk nan"}):_vm._e(),(_vm.gender==2&&_vm.isGender)?_c('i',{staticClass:"wzk-nv wzk nv"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }